import { graph_v1 } from 'store/api/graph_v1'
import { call, put } from 'typed-redux-saga'

export function* saga_getApplicationsForUser() {
  const action = graph_v1.endpoints.getApplicationsForUser.initiate()
  const promise = yield* put(action)
  promise.unsubscribe()
  return yield* call(promise.unwrap)
}
